import React from 'react';
import styles from './CustomCardList.module.css';
import CustomCard from '../customCard/CustomCard';

type CustomCardListType = {
    list: CustomCardType[];
    onLike?: Function;
    onClick: Function;
    onShare: Function;
    imagesAlt: string;
    hoverText: string;
}

const CustomCardList = (props: CustomCardListType) => {
    return (
        <div className={styles.containerList}>
            { props.list.map((item, index) => (
                <CustomCard
                    key={index}
                    data={item}
                    hoverText={props.hoverText}
                    imageUrl={`${process.env.REACT_APP_API_BASE_URL}${item.image.url}`}
                    imageAlt={props.imagesAlt}
                    onClick={() => props.onClick(item.documentId)}
                    onLike={props.onLike}
                    onShare={() => props.onShare(`${item.documentId}`, item.title, item.description)}
                />
            ))}
        </div>
    );
}

export default CustomCardList;